// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  development: true,
  apiEndpoint: 'https://dev-packcert-api.gesvatec.com/api',
  dashboardGeneral: 'https://dev-packcert-dashboard.gesvatec.com',
  dashboardEnv: 'DEV',
  denominacionGisEdicion: 'https://dev-packcert-gisedit.gesvatec.com',

  // apiEndpoint: 'https://demo-denominacion-api.azurewebsites.net/api',
  // dashboardPackersControl: 'https://gsvkoop-dev.westeurope.cloudapp.azure.com/DEMO/DENO/DENOGISETQ/?',
  // dashboardCultivosControl: 'https://gsvkoop-dev.westeurope.cloudapp.azure.com/DEMO/DENO/DENOGISHUE/?',
  // dashboardDesignacionesControl: 'https://gsvkoop-dev.westeurope.cloudapp.azure.com/DEMO/DENO/DENOGISDSG/?',
  // dashboardRoyaltiesControl: 'https://gsvkoop-dev.westeurope.cloudapp.azure.com/DEMO/DENO/DENOGISROY/?',
  // denominacionGisEdicion: 'https://gsvkoop-dev.westeurope.cloudapp.azure.com/DEMO/DENO/DENOGISEDC/?'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
